import { render, staticRenderFns } from "./migrationpembayaranangsuran.vue?vue&type=template&id=39b77cbd&scoped=true&"
import script from "./migrationpembayaranangsuran.vue?vue&type=script&lang=js&"
export * from "./migrationpembayaranangsuran.vue?vue&type=script&lang=js&"
import style0 from "./migrationpembayaranangsuran.vue?vue&type=style&index=0&id=39b77cbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b77cbd",
  null
  
)

export default component.exports